import StoredLayout from '../../layouts/StoredLayout'
import DonutChartWidgets from './DonutChartWidgets'
export default StoredLayout(DonutChartWidgets)



// WEBPACK FOOTER //
// ./src/widgets/donut-chart-widgets/index.js